import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "outer" }

import { ref, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { showError } from '@services/utils/dialog';

import Modal from './Modal.vue';
import AlbumForm from './AlbumForm.vue';

import { useModal } from '@services/modal';
import { t } from '@services/l10n';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import * as utils from '@services/utils/common';
import * as dav from '@services/dav';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AlbumCreateModal',
},
  __name: 'AlbumCreateModal',
  setup(__props, { expose: __expose }) {



const route = useRoute();
const router = useRouter();
const modal = useTemplateRef('modal');
const { show, close } = useModal(modal);

const album = ref<any>(null);
const abort = useAbort();

/**
 * Open the modal
 * @param edit If true, the modal will be opened in edit mode
 */
async function open(edit: boolean) {
  const signal = abort.renew();
  if (edit) {
    try {
      album.value = await dav.getAlbum(route.params.user?.toString(), route.params.name?.toString(), { signal });
      signal.throwIfAborted();
    } catch (e) {
      if (isAbortError(e)) return;
      console.error(e);
      showError(t('memories', 'Could not load the selected album'));
      return;
    }
  } else {
    album.value = null;
  }

  show.value = true;
}

function cleanup() {
  abort.abort();
  show.value = false;
}

async function done({ album: newAlbum }: { album: { basename: string; filename: string } }) {
  // close modal first to pop fragments
  await close();

  // navigate to album if name changed
  if (!album.value || newAlbum.basename !== album.value.basename) {
    const user = newAlbum.filename.split('/')[2];
    const name = newAlbum.basename;
    const target = { name: 'albums', params: { user, name } };

    if (!album.value) {
      await router.push(target);
    } else {
      await router.replace(target);
    }
  } else {
    // refresh timeline for metadata changes
    utils.bus.emit('memories:timeline:soft-refresh', null);
  }
}

__expose({ open });

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        ref_key: "modal",
        ref: modal,
        onClose: cleanup,
        size: "small"
      }, {
        title: _withCtx(() => [
          (!album.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Create new album')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Edit album details')), 1)
              ], 64))
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AlbumForm, {
              album: album.value,
              "display-back-button": false,
              title: _unref(t)('memories', 'New album'),
              onDone: done
            }, null, 8, ["album", "title"])
          ])
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})